import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router';
import { useParams } from "react-router-dom";
import axios from 'axios';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import UserContext from '../../UserContext';
import Direction from './Direction';
import ConfirmPayTypeModal from './ConfirmPayTypeModal';

const DirectionContainer = () => {
  const history = useHistory();

  const { clinicId, buildingId, specialisationId, cabinetId, doctor, categoryType, isReferral, typeServices } = useParams();

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [isDirection, setIsDirection] = useState(isReferral === '1' ? 'yes' : 'no');
  const [filterStr, setFilterStr] = useState('');
  const [isOpenConfirmDialog, setIsOpenConfirmDialog] = useState(false);

  const [companyList, setCompanyList] = useState([]);

  const {
    setPayType,
    setSendingCompanyId,
    sendingCompanyId,
    payType,
    setIsDisabledNextBtn,
    isDisabledNextBtn,
  } = useContext(UserContext);

  const getCompanyList = () => {
    setIsLoading(true);
    axios.get(`${process.env.REACT_APP_API}api/v1.0/company?medicalOrganizationId=${process.env.REACT_APP_MEDICAL_ORGANIZATION_ID}&filterStr=${filterStr}`, {
      headers: {
        ...unauthHeaders,
        Authorization: `Bearer ${sessionStorage.getItem('token')}`,
      }
    })
      .then((res) => {
        setIsLoading(false);
        setCompanyList(res.data);
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(err.response.data.message);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    if (isReferral === '1') {
      setPayType('Oms');
    } else {
      setPayType('Cash')
    }

    setIsDisabledNextBtn(false);
    getCompanyList();
  }, [])

  useEffect(() => {
    if (filterStr) {
      getCompanyList();
      onChangeIsDirection('yes');
    }
  }, [filterStr]);

  const onChangeIsDirection = (e) => {
    setIsDirection(e);

    if (e === 'yes') {
      setPayType('Oms');
    } else {
      setPayType('Cash');
      setSendingCompanyId(null);
      setIsOpenConfirmDialog(true);
    }

    if (e === 'no') {
      setIsDisabledNextBtn(false);
    } else {
      setIsDisabledNextBtn(true);
    }
  }

  const handleSelectCompany = (companyId) => {
    setSendingCompanyId(companyId);
    // setIsDisabledNextBtn(false);
    // setIsDisabledNextBtn(true);
    setTimeout(() => {
      history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/schedule/${clinicId}/${specialisationId}/${cabinetId}/${doctor}/${categoryType}/${buildingId}/${typeServices}`);
    }, 200);

  }

  const handleClickNextBtn = () => {
    if (isDisabledNextBtn) {
      return
    }
    setIsDisabledNextBtn(true);
    history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/schedule/${clinicId}/${specialisationId}/${cabinetId}/${doctor}/${categoryType}/${buildingId}/${typeServices}`);
  }

  const handleCloseConfirmDialog = () => {
    setIsDisabledNextBtn(true);
    setIsOpenConfirmDialog(false);
    setIsDirection('yes');
    setPayType('Oms');
  }

  const handleConfirmConfirmDialog = () => {
    handleClickNextBtn();
  }

  return (
    <>
      {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
      <Direction
        isLoading={isLoading}
        isDirection={isDirection}
        onChangeIsDirection={onChangeIsDirection}
        companyList={companyList}
        filterStr={filterStr}
        setFilterStr={setFilterStr}
        handleSelectCompany={handleSelectCompany}
        handleClickNextBtn={handleClickNextBtn}
        sendingCompanyId={sendingCompanyId}
      />
      <ConfirmPayTypeModal
        open={isOpenConfirmDialog}
        handleConfirm={handleConfirmConfirmDialog}
        handleClose={handleCloseConfirmDialog}
      />
    </>
  )
}

export default DirectionContainer;
